import { useState } from "react";
import emailjs from "emailjs-com";
import React from "react";
import Swal from 'sweetalert2';
import WhatsAppIcon from './whatsapp'
import GoogleMap from './mapa'

const initialState = {
  name: "",
  email: "",
  message: "",
};
export const Contact = (props) => {
  const [{ name, email, message }, setState] = useState(initialState);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({ ...prevState, [name]: value }));
  };
  const clearState = () => setState({ ...initialState });


  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(name, email, message);

    {/* replace below with your own Service ID, Template ID and Public Key from your EmailJS account */ }

    emailjs
      .sendForm("service_ne0fyjg", "template_7yxpr09", e.target, "YHEcMG8hqFTPPs3V5")
      .then(
        (result) => {
          console.log(result.text);
          // Muestra un mensaje de éxito
          Swal.fire({
            title: "Correo enviado exitosamente",
            text: "Serás contactado en breve a través de tu bandeja de correo electrónico",
            icon: "success"
          });
          // Limpia el estado del formulario
          clearState();
        },
        (error) => {
          console.log(error.text);
          Swal.fire({
            title: "Error al enviar el correo",
            text: error.text,
            icon: "error"
          });
        }
      );
  };
  return (
    <div>
      <div id="contact">
        <div className="container">
          <div className="col-md-8">
            <div className="row">
              <div className="section-title">
                <h2>Ponte en contacto</h2>
                <p>
                  Por favor, completa el formulario a continuación para enviarnos un correo electrónico y nos pondremos en contacto contigo lo antes posible.
                </p>
              </div>
              <form name="sentMessage" validate onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="text"
                        id="name"
                        name="name"
                        className="form-control"
                        placeholder="Nombre"
                        required
                        onChange={handleChange}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="email"
                        id="email"
                        name="email"
                        className="form-control"
                        placeholder="Email"
                        required
                        onChange={handleChange}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <textarea
                    name="message"
                    id="message"
                    className="form-control"
                    rows="4"
                    placeholder="Mensaje"
                    required
                    onChange={handleChange}
                  ></textarea>
                  <p className="help-block text-danger"></p>
                </div>
                <div id="success"></div>
                <button type="submit" className="btn btn-custom btn-lg">
                  Enviar mensaje
                </button>
              </form>
              <GoogleMap/>
            </div>
          </div>
          <div className="col-md-3 col-md-offset-1 contact-info">
            <div className="contact-item">
              <h3>Información de contacto</h3>
              <p>
                <span>
                  <i className="fa fa-map-marker"></i> Dirección
                </span>
                {props.data ? (
                  <a href="https://maps.app.goo.gl/XkEjZgHTPkZ1vMpb9" target="_blank" rel="noopener noreferrer" style={{ color: 'white' }}>
                    {props.data.address}
                  </a>
                ) : (
                  "loading"
                )}
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-phone"></i> Teléfono | {" "} <i className="fa fa-whatsapp"></i>WhatsApp

                </span>{" "}
                {props.data ? (
                  <a href={`https://wa.me/+52${props.data.phone}`} target="_blank" rel="noopener noreferrer" style={{ color: "white" }}>
                    {props.data.phone}
                  </a>
                ) : (
                  "loading"
                )}
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-envelope-o"></i> Email
                </span>{" "}
                {props.data ? (
                  <a href={`mailto:${props.data.email}`} style={{ color: 'white' }}>{props.data.email}</a>
                ) : (
                  "loading"
                )}
                <br />
                <p>
                  {props.data ? (
                    <a href={`mailto:${props.data.email2}`} style={{ color: 'white' }}>{props.data.email2}</a>
                  ) : (
                    "loading"
                  )}
                </p>
              </p>
            </div>

            
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-calendar"></i> Horario de servicio:
                </span>{" "}
                <p>Lun-Vie: 9 a. m. - 7 p. m.</p>
                <p>Sábado: 9 a. m. - 4 p. m.</p>
                <p>Domingo: Cerrado</p>
              </p>
            </div>
            <WhatsAppIcon />

          </div>
          <div className="col-md-12">
            <div className="row">
              <div className="social">
                <ul>
                  <li>
                    <a target="_blank" href={props.data ? props.data.facebook : "/"}>
                      <i className="fa fa-facebook"></i>
                    </a>
                  </li>
                  {/* <li>
                    <a href={props.data ? props.data.twitter : "/"}>
                      <i className="fa fa-twitter"></i>
                    </a>
                  </li>
                  <li>
                    <a href={props.data ? props.data.youtube : "/"}>
                      <i className="fa fa-youtube"></i>
                    </a>
                  </li> */}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="footer">
        <div className="container text-center">
          <p>
            &copy; Desarrollado por
            <a href="https://tecnologiasadministrativas.com/" rel="nofollow" target="_blank">
              {" "}TAE
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};
